/* eslint-disable class-methods-use-this */
/* eslint-disable no-magic-numbers */
import Phase from '../phase-core/Phase';

export default class Nothing extends Phase {
	getPreludeLength() {
		return 0;
	}
	getPostludeLength() {
		return 0;
	}
	run() {
		void 0;
	}
}
